/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import annotationPlugin from 'chartjs-plugin-annotation';
import { AnalyticsService } from './services/analytics.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { first } from 'rxjs/operators';
import { MenuService } from './services/menu.service';
import { NbIconLibraries } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceDisruptionModalComponent } from './shared/components/service-disruption-modal/service-disruption-modal.component';
import { SharedService } from './services/shared.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private translate: TranslateService,
    private sharedService: SharedService,
    private menuService: MenuService,
    private toastrService: ToastrService,
    private iconLibraries: NbIconLibraries,
    private changeDetectorRef: ChangeDetectorRef,
    private modalService: NgbModal
  ) {
    this.iconLibraries.registerFontPack('nebular', { iconClassPrefix: 'nb' });
    this.iconLibraries.registerFontPack('solid', { packClass: 'fas', iconClassPrefix: 'fa' });
    this.iconLibraries.registerFontPack('regular', { packClass: 'far', iconClassPrefix: 'fa' });
    this.iconLibraries.registerFontPack('kit', { packClass: 'fa-kit', iconClassPrefix: 'fa' });
    this.iconLibraries.setDefaultPack('solid');
  }

  async ngOnInit() {

    try {
      await this.sharedService.getMeData();
    } catch (error) {
      this.toastrService.error(
        error.message,
        'Error',
        { closeButton: true, disableTimeOut: true, tapToDismiss: false, enableHtml: true });
    }

    this.analytics.trackPageViews();

    // Add languages
    this.translate.addLangs(['en', 'da', 'sv']);

    // Set the default language
    const languageId = this.sharedService.userPreferences?.selectedLanguageId || 'en';

    this.translate.setDefaultLang(languageId);
    await this.translate.use(languageId).pipe(first()).toPromise();

    this.menuService.initializeMenu();

    Chart.defaults.font.family = '"Poppins","Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';
    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    document.getElementById('initial-loader').remove();

    this.showServiceDisruption();
    this.changeDetectorRef.detectChanges();
  }

  private async showServiceDisruption() {
    const showServiceDisruption = this.sharedService.currentCompany?.Settings?.ShowServiceDisruption;

    if (showServiceDisruption) {
      this.modalService.open(ServiceDisruptionModalComponent, { size: 'lg', backdrop: 'static', centered: true });
    }
  }
}
